import React from 'react';
import { Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const StyleButton = props => {
  const onToggle = e => {
    e.preventDefault();
    props.onToggle(props.style);
  };

  return <Button icon={props.icon} active={props.active} onMouseDown={onToggle} />;
};

StyleButton.propTypes = {
  style: PropTypes.any,
  icon: PropTypes.string,
  active: PropTypes.any,
  onToggle: PropTypes.func,
};

export default StyleButton;
